<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="1000px"
      :title="title"
      :close-on-click-modal="false"
      append-to-body
      :before-close="() => $refs.detailForm.cancel()"
    >
      <DetailForm
        ref="detailForm"
        :disabled="disabled"
        :orderGoodsSpecCode="orderGoodsSpecCode"
        :changeOrderGoodsCode="changeOrderGoodsCode"
        @close="$emit('close')"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.detailForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!disabled"
          @click="$refs.detailForm.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DetailForm from './index.vue'
export default {
  components: { DetailForm },
  props: {
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    changeOrderGoodsCode: String,
    orderGoodsSpecCode: String,
  },
  methods: {},
}
</script>
